<template>
  <el-calendar :first-day-of-week="parseInt(7)" v-model="value">
    <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
    <template slot="dateCell" slot-scope="{ date, data }">
      <p style="white-space: pre-line;">
        {{ solarDate2lunar(data.day) }}
      </p>
      <div class="calendar-custom">
        <ul class="calendar-data">
          <li v-for="item in calendarData">
            <template v-if="(item.data.split('-').slice(0)[0]).indexOf(data.day.split('-').slice(0)[0])!=-1">
              <template v-if="(item.data.split('-').slice(0)[1]).indexOf(data.day.split('-').slice(0)[1])!=-1">
                <template v-if="(item.data.split('-').slice(0)[2]).indexOf(data.day.split('-').slice(0)[2])!=-1">
                  <span class="time">{{item.time}}</span><span class="name" :title="item.things">{{item.things}}</span>
                </template>
              </template>
            </template>
          </li>
        </ul>
        <div style="text-align: center">
          <el-button type="primary" size="mini" style="width:100px" @click.stop="$emit('sign-up','explain',true,data)">报名</el-button>
          <!-- <el-button type="info" size="mini" style="width:100px">查看</el-button> -->
        </div>

      </div>

    </template>
  </el-calendar>
</template>

<script>
import calendar from '@/libs/calendar'
export default {
  components: {},
  props: {
    calendarData: {
      //日历中有事件的数组
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      value: new Date(),

    };
  },
  computed: {},
  watch: {},
  methods: {
    solarDate2lunar(solarDate) {

      var solar = solarDate.split('-')
      var lunar = calendar.solar2lunar(solar[0], solar[1], solar[2])
      // return solar[1] + '-' + solar[2] + '\n' + lunar.IMonthCn + lunar.IDayCn
      return lunar.IDayCn == "初一" ? solar[2] + '\t' + lunar.IMonthCn : solar[2] + '\t' + lunar.IDayCn
    },
  },
  filters: {
    // 农历显示
    solarDate2lunar(solarDate) {

      var solar = solarDate.split('-')
      var lunar = calendar.solar2lunar(solar[0], solar[1], solar[2])
      // return solar[1] + '-' + solar[2] + '\n' + lunar.IMonthCn + lunar.IDayCn
      return lunar.IDayCn == "初一" ? solar[2] + '\t' + lunar.IMonthCn : solar[2] + '\t' + lunar.IDayCn
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", e => {
        // console.log(this.value.getFullYear(), this.value.getMonth() + 1, this.value.getDate());

      });

      //点击下一个月
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", () => {
        // console.log(this.value.getFullYear(), this.value.getMonth() + 1, this.value.getDate());
      });

      //点击今天
      let todayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      todayBtn.addEventListener("click", () => {
        // console.log(this.value.getFullYear(), this.value.getMonth() + 1, this.value.getDate());
      });
    });

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "~@views/serviceCenter/components/calendar/calendar.less";
/deep/.el-calendar-table .el-calendar-day {
  height: 190px;
}
.calendar-data {
  height: 90px;
  li {
    .time {
      width: 43px;
    }
    .name {
      width: calc(100% - 43px);
    }
  }
}
</style>
